"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./i18nTypes"), exports);
tslib_1.__exportStar(require("./i18nUtil"), exports);
//# sourceMappingURL=index.js.map